// ─────────────────────────────────────────────────────────────
// LukaDuka — ProfileLoadErrorScreen (ver1)
//
// Shown when a signed-in user's profile could not be loaded after
// retrying (Bug P20). Never treat a failed load as "needs onboarding" -
// that used to route an already-onboarded user back through the
// date-of-birth screen, and completing it would create a duplicate
// birth record. This screen is the honest alternative: say the load
// failed, reassure the user their data is safe, and let them retry.
//
// Rendered directly by Router.tsx, before SettingsProvider mounts, so
// (like OnboardingFlow) it uses hardcoded fallback colours rather than
// --ui-* theme variables that aren't applied yet.
// ─────────────────────────────────────────────────────────────

interface ProfileLoadErrorScreenProps {
  onRetry: () => void
}

export function ProfileLoadErrorScreen({ onRetry }: ProfileLoadErrorScreenProps) {
  return (
    <div style={page}>
      <p style={body}>
        We couldn't open your story just now. Your memories are safe. Try
        again in a moment.
      </p>
      <button type="button" onClick={onRetry} style={button} name="ld-profileerror-x1">
        Try again
      </button>
    </div>
  )
}

const page: React.CSSProperties = {
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: 20,
  padding: 32,
  background: 'var(--ui-bg, #EDE4D8)',
}

const body: React.CSSProperties = {
  fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
  fontSize: 15,
  color: 'var(--ui-text, #1C1917)',
  lineHeight: 1.6,
  maxWidth: 320,
  margin: 0,
}

const button: React.CSSProperties = {
  padding: '14px 28px',
  borderRadius: 12,
  border: 'none',
  background: 'var(--ui-accent, #5B7A5E)',
  color: '#FFFFFF',
  fontSize: 15,
  fontWeight: 600,
  fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
  cursor: 'pointer',
}
